import { createRouter } from '@tanstack/react-router';
import { NotFoundPage } from '../pages';
import { routeTree } from '../routeTree.gen';

// Create the router using your route tree
export const router = createRouter({ routeTree, defaultNotFoundComponent: NotFoundPage });

declare module '@tanstack/react-router' {
  interface Register {
    // This infers the type of our router and registers it across your entire project
    router: typeof router;
  }
}
